import styles from "../styles/pages/profile/profile.module.sass";
import { Spin, Upload } from "antd";
import ImgCrop from "antd-img-crop";
import { AiTwotoneEdit } from "react-icons/ai";
import { useState } from "react";
import axios from "axios";
import { getProfileData } from "../redux/profile/actions";
import { expiredTokenHandler } from "../utility/helper";
import useUserData from "../hooks/useUserData";
import { useDispatch } from "react-redux";

const getSrcFromFile = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file.originFileObj);
    reader.onload = () => resolve(reader.result);
  });
};

function ChangeAvatar({ icon, spinSize = "default" }) {
  const [uploading, setUploading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [imgCropOpen, setImgCropOpen] = useState(false); // Control ImgCrop visibility

  const { username, email } = useUserData();

  const dispatch = useDispatch();

  const onChange = ({ fileList: newFileList }) => {
    const lastFile = newFileList?.[newFileList.length - 1];

    setFileList([lastFile]);

    if (lastFile?.originFileObj) {
      setUploading(true);
      getBase64(lastFile.originFileObj, (editedBase64) => {
        resizeImage(editedBase64, 300, 300, (compressedBase64) => {
          const hexString = base64ToHex(compressedBase64);
          axios
            .post(
              "https://jvp2fozucc.execute-api.us-east-1.amazonaws.com/dev/api",
              {
                platform_mode: "profile",
                email: email,
                user: username,
                request_type: "set_profile_image",
                file: hexString,
              },
            )
            .then((res) => {
              dispatch(getProfileData(email, username));
            })
            .catch((err) => {
              console.error("Upload Error: ", err);
              if (err?.response?.status === 450) {
                expiredTokenHandler();
              }
            })
            .finally(() => setUploading(false));
        });
      });
    }
  };

  // Convert File to Base64
  function getBase64(file, callback) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      callback(reader.result); // Now we pass the entire Base64 image for editing
    };
    reader.onerror = function (error) {
      console.error("FileReader Error: ", error);
    };
  }

  // Resize & Compress Image (AFTER Editing)
  function resizeImage(base64, maxWidth, maxHeight, callback) {
    const img = new Image();
    img.src = base64;
    img.onload = function () {
      const canvas = document.createElement("canvas");
      let width = img.width;
      let height = img.height;

      if (width > maxWidth || height > maxHeight) {
        const aspectRatio = width / height;
        if (width > height) {
          width = maxWidth;
          height = width / aspectRatio;
        } else {
          height = maxHeight;
          width = height * aspectRatio;
        }
      }

      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);

      // Convert to compressed Base64
      const compressedBase64 = canvas.toDataURL("image/jpeg", 0.7); // 70% quality
      callback(compressedBase64);
    };

    img.onerror = function (error) {
      console.error("Image Processing Error:", error);
    };
  }

  // Convert Base64 to Hex
  function base64ToHex(str) {
    const raw = atob(str.split(",")[1]); // Remove metadata
    let result = "";
    for (let i = 0; i < raw.length; i++) {
      const hex = raw.charCodeAt(i).toString(16);
      result += hex.length === 2 ? hex : "0" + hex;
    }
    return result;
  }

  const onPreview = async (file) => {
    const src = file.url || (await getSrcFromFile(file));
    const imgWindow = window.open(src);
    if (imgWindow) {
      const image = new Image();
      image.src = src;
      imgWindow.document.write(image.outerHTML);
    } else {
      window.location.href = src;
    }
  };

  return (
    <>
      {uploading && (
        <div className={styles.loader}>
          <Spin size={spinSize} />
        </div>
      )}
      <span>
        <ImgCrop
          showGrid
          rotationSlider
          showReset
          modalTitle="Edit Profile Image"
          modalProps={{ open: imgCropOpen }}
          onModalCancel={() => setImgCropOpen(false)}
        >
          <Upload
            fileList={fileList}
            onChange={onChange}
            onPreview={onPreview}
            disabled={uploading}
          >
            {!uploading && (icon || <AiTwotoneEdit />)}
          </Upload>
        </ImgCrop>
      </span>
    </>
  );
}

export default ChangeAvatar;
